module.exports = __webpack_public_path__ + "files/799b647d61ba552393a31b9d1d3cc86b.png";